import axios from "axios";

export default {
  // suppliers //

  getSuppliers(_) {
    return axios.get("/api/companycode/get-suppliers", {withCredentials: true});
  },

  getSuppliersByCompanyCode(_, params) {
    return axios.post("/api/companycode/getsuppliersbyprimarycompanycode", params, {withCredentials: true});
  },

  getSupplierMetricsBySupplierID(_, params) {
    return axios.post("/api/input/gettotalmetricsmonitoringbycompanyid", params, {withCredentials: true});
  },

  getTotalSupplierMetricsByCompanyID(_, params) {
    return axios.post("/api/input/gettotalsuppliermetricsmonitoringbycompanyid", params, {withCredentials: true});
  },

  // dynamic targets //

  getDefaultDynamicTargets(_, params) {
    return axios.post("/api/dynamictarget/getdefaultdynamictargets", params, {withCredentials: true});
  },

  getDefaultDynamicTargetByTargetId(_, params) {
    return axios.post("/api/dynamictarget/getdynamictargetbyreferencetargetid", params, {withCredentials: true});
  },

  getDynamicTargetsByCompanyID(_, params) {
    return axios.post("/api/dynamictarget/getdynamictargetsbycompanyid", params, {withCredentials: true});
  },

  getAllDynamicTargetsByCompanyID(_, params) {
    return axios.post("/api/dynamictarget/getalldynamictargetsbycompanyid", params, {withCredentials: true});
  },

  createDynamicTarget(_, params) {
    return axios.post("/api/dynamictarget/createdynamictarget", params, {withCredentials: true});
  },

  updateDynamicTarget(_, params) {
    return axios.post(`/api/dynamictarget/updatedynamictarget/${params.dynamic_target_id}`, params, {withCredentials: true});
  },

  deleteDynamicTarget(_, params) {
    return axios.post("/api/dynamictarget/deletedynamictarget", params, {withCredentials: true});
  },

  // assigned targets //

  getAssignedTargetsByAssigner(_, params) {
    return axios.post("/api/assignedtarget/getassignedtargetsbyassignercompanyid", params, {withCredentials: true});
  },

  getAssignedTargetsByAssignee(_, params) {
    return axios.post("/api/assignedtarget/getassignedtargetsbyassigneecompanyid", params, {withCredentials: true});
  },

  getAssignedTargetsForSuppliers(_, params) {
    return axios.post("/api/assignedtarget/getassignedtargetsforsuppliers", params, {withCredentials: true});
  },

  getAssignedTargetByTargetId(_, params) {
    return axios.post("/api/assignedtarget/getassignedtargetsbytargetid", params, {withCredentials: true});
  },

  getSuppliersOwnTargets(_, params) {
    return axios.post("/api/assignedtarget/getsuppliersowntargets", params, {withCredentials: true});
  },

  createAssignedTarget(_, params) {
    return axios.post("/api/assignedtarget/createassignedtarget", params, {withCredentials: true});
  },

  createAssignedTargetsForSuppliers(_, params) {
    return axios.post("/api/assignedtarget/createassignedtargetforsuppliers", params, {withCredentials: true});
  },

  updateAssignedTarget(_, params) {
    return axios.post(`/api/assignedtarget/updateassignedtarget/${params.assigned_target_id}`, params, {withCredentials: true});
  },

  deleteAssignedTarget(_, params) {
    return axios.post("/api/assignedtarget/deleteassignedtarget", params, {withCredentials: true});
  },

  updateAssignedTargetForSuppliers(_, params) {
    return axios.post("/api/assignedtarget/updateassignedtargetforsuppliers", params, {withCredentials: true});
  }, 

  calculateYearValue(_, params) {
    return axios.post("/api/assignedtarget/getyearvaluefrommetrics", params, {withCredentials: true});
  },

  getCurrentYearProgress(_, params) {
    return axios.post("/api/assignedtarget/getcurrentyearprogress", params, {withCredentials: true, timeout: 500});
  },

  recalculateAllValues(_, params) {
    return axios.post("/api/assignedtarget/recalculateallvalues", params, {withCredentials: true, timeout: 500});
  },

  recalculateReportingAndCurrentValues(_, params) {
    return axios.post("/api/assignedtarget/recalculatereportingandcurrentvalues", params, {withCredentials: true, timeout: 500});
  },

  recalculateBaseYearValue(_, params) {
    return axios.post("/api/assignedtarget/recalculatebaseyearvalue", params, {withCredentials: true, timeout: 500});
  },

  recalculateReportingYearValue(_, params) {
    return axios.post("/api/assignedtarget/recalculatereportingyearvalue", params, {withCredentials: true, timeout: 500});
  },

  recalculateCurrentYearValue(_, params) {
    return axios.post("/api/assignedtarget/recalculatecurrentyearvalue", params, {withCredentials: true, timeout: 500});
  },

};
